import React, { useState, useEffect } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Card, CardBody, Col, Container, Row, Form } from "reactstrap";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Loader } from "../Utils/Loader";
import { validationSchema } from "./constants/ValidationSchema";
import CommonButton from "../Utils/CommonButton";
import { PAGE_TITLES } from "../Common/constants";
import { PolicyForm } from "./PolicyForm";
import Attribute from "./Attribute";
import { handleChangeForAttributeValue } from "./constants/jsonconstant";
import { isEmptyOrInvalidField } from "./constants/jsonconstant";
import schema from './schema.json';
import { getAllResources } from "../../slices/resources/thunk";
import { createPolicies } from "../../slices/Policy/CreatePolicy/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { getPoliciesByName } from "../../slices/Policy/GetPolicyByName/thunk";
import { updatePolicies } from "../../slices/Policy/UpadatePolicy/thunk";

export default function CreatePolicy() {
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [enableFormReinitialize, setEnableFormReinitialize] = useState(false);
  const [deviceID, setDeviceID] = useState([]);
  const [initialValues, setInitialValues] = useState({
    policyLabel: "",
    resource: "",
    status: "",
    attributeList: [
      {
        rangeStarts: '0',
        rangeEnds: '',
        statusLabel: '',
      }
    ],
    unitofmeasurement: ""
  });

  const isEdit = location.pathname.includes('/edit-policies');
  const policy = customerIdData();
  const [title, setTitle] = useState("");
  useEffect(() => {
    setTitle(PAGE_TITLES.ADD_POLICY);
    if (isEdit) {
      setTitle(PAGE_TITLES.UPDATE_POLICY);
      dispatch(getPoliciesByName(policy, setLoading, setInitialValues));
    }
  }, [dispatch, isEdit, policy]);
  useEffect(() => {
    dispatch(getAllResources(setLoading));
  }, [dispatch]);
  const resources = useSelector((state) => state.Resources.resources);
  useEffect(() => {
    if (resources?.length > 0) {
      const filteredResources = resources?.filter(resource => !resource.isCurrency);
      schema.fields[1].options = filteredResources?.map((resource) => ({
        value: resource?.name,
        label: resource?.name,
        unitofmeasurement: resource?.unitofmeasurement
      }));
      setEnableFormReinitialize(true);
    }
  }, [resources]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={enableFormReinitialize}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        if (
          values?.policyLabel !== "" &&
          values?.resource !== "" &&
          values?.attributeList?.length > 0
        ) {
          let unitOfMeasurement;
          if (isEdit) {
            unitOfMeasurement = values?.unitofmeasurement?.value || values?.unitofmeasurement;
          } else {
            unitOfMeasurement = values?.unitofmeasurement;
          }

          const formattedValues = {
            policyLabel: values?.policyLabel,
            resourceName: values?.resource?.value || values?.resource,
            unitofmeasurement: unitOfMeasurement,
            rules: values?.attributeList.map(attr => ({
              rangeStart: parseInt(attr?.rangeStarts),
              rangeEnd: parseInt(attr?.rangeEnds),
              statusLabel: attr?.statusLabel
            }))
          };

          if (!isEdit) {
            dispatch(createPolicies(formattedValues, setLoading, navigate));
          } else {
            dispatch(updatePolicies(setLoading, formattedValues, navigate));
          }
        }
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        values,
        setFieldValue,
        setFieldTouched,
        setTouched,
      }) => (
        <Form className="needs-validation" onSubmit={handleSubmit}>
          {loading && <Loader />}
          <div id='csms' className='page-content bg-white mb-0'>
            <Container fluid>
              <BreadCrumb title={title} pageTitle="Policy" moduleTitle="Policy Specs" />
              <ToastContainer position='top-center' />
              <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
                <div className="d-flex flex-row gap-2">
                  <h5 className="rv-page-title p-2">{!isEdit?'Add Policy':'Edit Policy'}</h5>
                </div>
              </div>
              <div className="border rounded-1 p-3">
                <PolicyForm
                  values={values}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                  handleChange={handleChange}
                  schema={schema}
                  isEdit={isEdit}
                />
                <Attribute
                  values={values}
                  touched={touched}
                  errors={errors}
                  initialValues={initialValues}
                  setTouched={setTouched}
                  handleChange={handleChange}
                  handleChangeForAttributeValue={handleChangeForAttributeValue}
                  isEmptyOrInvalidField={isEmptyOrInvalidField}
                  deviceID={deviceID}
                  isEdit={isEdit}
                  setFieldValue={setFieldValue}
                />
              </div>
              {/* <Row lg={6} className="justify-content-end mb-4"> */}
                {/* <div className="live-preview">
                  <div className="d-flex justify-content-end gap-2">
                    <CommonButton color={"cancel-button-color"} type={"reset"} buttonAction={() => navigate('/policies')} buttonText={"Cancel"} />
                    <CommonButton color={"main-color"} type={'submit'} buttonText={"Confirm"} />
                  </div>
                </div> */}
                <div className="live-preview">
                  <div className="d-flex gap-2 justify-content-end mt-4">
                    <div className="d-flex justify-content-center gap-2">
                      <CommonButton
                        outline
                        type="reset"
                        className={
                          "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                        }
                        color={"main-color"}
                        buttonAction={() => navigate('/policies')}
                        buttonText={"Close"}
                        icon={
                          <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                        }
                        btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                      />
                      <CommonButton
                        color={"main-color"}
                        className={
                          "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                        }
                        icon={
                          <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                        }
                        btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                        type="submit"
                        buttonText={"Submit"}
                      />
                    </div>
                  </div>
                </div>
              {/* </Row> */}
              {/* </Col>
                </Row> */}
            </Container>
          </div>
        </Form>
      )}
    </Formik>
  );
}